export default __webpack_public_path__ + "static/media/home-main-sm.83e39010.jpg";